module.exports = __webpack_public_path__ + "static/img/software-card-bg1.png";